var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVtb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95505 8L6.71401 14.1472H37.759L40 8H8.95505ZM5.59479 17.2182L3.35375 23.3642H34.3987L36.6397 17.2182H5.59479ZM2.24104 26.4365L0 32.5811H31.045L33.2834 26.4352C33.2847 26.4365 2.24104 26.4365 2.24104 26.4365Z",
    fill: "#009FDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtb);
export default __webpack_public_path__ + "static/media/vtb.446294548971302f4b6ac91ce32b5282.svg";
export { ForwardRef as ReactComponent };